import React from "react";
import { Typography } from '@mui/material';
import "./Switch.css";

type SwitchProps = {
  isOn: boolean;                           // ON/OFF状態
  onToggle: (value: boolean) => void;      // 状態変更時のコールバック
  label?: string;                          // ラベル（常に同じテキスト）
  showLabel?: boolean;                     // ラベル表示の有無（デフォルト true）
};

export const Switch: React.FC<SwitchProps> = ({
  isOn,
  onToggle,
  label = "",
  showLabel = true,
}) => {
  return (
    <div className="switch-container">
      <Typography variant="body1">
        {showLabel && <span>{label}</span>}
      </Typography>
      <div
        className={`switch ${isOn ? "on" : "off"}`}
        onClick={() => onToggle(!isOn)}
      >
        <div className="thumb" />
      </div>
    </div>
  );
};
